export const logixPanelRootURL = process.env.REACT_APP_LOGIX_PANEL_OLD_SITE_URL;

export const apiConfig = {
  apiUrl: process.env.REACT_APP_API_URL
};
